/* eslint no-underscore-dangle: 0 */
import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { I18n } from 'aws-amplify'
import { useAuth } from '../../../../presentation/contexts/auth'
import HelperAmplify from '../../../../presentation/helpers/helper-amplify'
import ForgotPassword from '../../../../presentation/pages/amplify/forgot-passwoord'

// import { Container } from './styles'

const MakeForgotPassword = () => {
  const [errorMessage, setErrorMessage] = useState<string | null>(null)
  const history = useHistory()
  const { setEmailToRecoveryPassword } = useAuth()

  const dataForm = [
    {
      items: [
        {
          name: 'email',
          component: 'Input',
          value: '',
          placeholder: 'Digite aqui',
          type: 'email',
          title: 'E-mail',
          label: 'E-mail',
          required: true,
          validations: 'emailRequired',
        },
        {
          name: 'button',
          component: 'Button',
          title: 'Enviar',
          submittingText: 'Enviando...',
        },
      ],
    },
  ]

  const onSubmit = async (values:any): Promise<void> => {
    const { email } = values

    try {
      await HelperAmplify.forgotPassword(email)
      setEmailToRecoveryPassword(email)

      history.push('/recovery-password')
    } catch (error: any) {
      const msg = I18n.get(error.name)
      setErrorMessage(msg)
    }
  }

  const goBack = () => {
    history.goBack()
  }

  return (
    <ForgotPassword
      dataForm={dataForm}
      onSubmit={onSubmit}
      errorMessage={errorMessage}
      goBack={goBack}
    />
  )
}

export default MakeForgotPassword
